// AR
export const hotelRatesManager = {
  perNight: "/ ليلة",
  roomFallback: "غرفة #{id}",

  header: {
    eyebrow: "الأسعار الرئيسية",
    title: "أسعار الفندق",
    subtitle:
      "أنشئ أسعارًا أساسية وطبّقها على غرفة واحدة أو عدة غرف. تتم مزامنة الأسعار المشتقة مع مدير القنوات.",
    newMain: "سعر رئيسي جديد",
  },
  states: {
    loading: "جارٍ تحميل الأسعار…",
    emptyTitle: "لا توجد أسعار بعد",
    emptySubtitle:
      "أنشئ أول سعر رئيسي لبدء إدارة الأسعار والمزامنة مع مدير القنوات.",
    createFirst: "إنشاء أول سعر",
  },
  card: {
    mainBadge: "رئيسي",
    occupancy: "الإشغال {count}",
    minStay: "الحد الأدنى {count} ليلة | الحد الأدنى {count} ليالٍ",
    editRate: "تعديل السعر",
    deleteRate: "حذف السعر",
    rooms: "الغرف",
    syncedTooltip: "متزامن مع مدير القنوات",
    removeSyncedTooltip: "إزالة (تحذير: مدير القنوات)",
    removeRoomTooltip: "إزالة من هذه الغرفة",
    add: "إضافة",
    selectRoom: "اختر غرفة",
    derivedBadge: "مشتق",
    derivedFrom: "من {name}",
    sameNameHint: "توجد «{name}» أخرى بسعر أو شروط مختلفة. تُعدَّل كل بطاقة على حدة.",
    editDerived: "تعديل المشتق",
    deleteDerived: "حذف المشتق",
  },
  derived: {
    toggle: "الأسعار المشتقة",
    empty:
      "لا توجد أسعار مشتقة بعد. أنشئ واحدًا لـ Booking.com أو Airbnb أو قنوات OTA محددة.",
    newDerived: "سعر مشتق جديد",
  },
  common: {
    allRooms: "جميع الغرف",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    creating: "جارٍ الإنشاء…",
    saveChanges: "حفظ التغييرات",
    removeAll: "إزالة الكل",
  },
  mainModal: {
    editTitle: "تعديل السعر الرئيسي",
    newTitle: "سعر رئيسي جديد",
    nameLabel: "الاسم",
    namePlaceholder: "مثال: السعر القياسي، عطلة نهاية الأسبوع…",
    priceLabel: "السعر لكل ليلة",
    occupancyLabel: "الإشغال",
    minStayLabel: "الحد الأدنى للإقامة (ليالٍ)",
    maxStayLabel: "الحد الأقصى للإقامة (ليالٍ)",
    validityLabel: "الصلاحية",
    permanent: "دائم",
    dateRange: "نطاق تواريخ",
    from: "من",
    to: "إلى",
    descriptionLabel: "الوصف (اختياري)",
    descriptionPlaceholder: "ملاحظات داخلية حول هذا السعر…",
    searchPlaceholder: "ابحث عن غرفة…",
    selectAllShort: "الكل",
    noResults: 'لا نتائج لـ "{query}"',
    noRoomsAvailable: "لا توجد غرف متاحة",
    editInfo: "ستُطبَّق التغييرات على {rooms} في هذه البطاقة.",
    createRate: "إنشاء سعر",
  },
  derivedModal: {
    editTitle: "تعديل السعر المشتق",
    newTitle: "سعر مشتق جديد",
    subtitle: "مشتق من {name} · {price}",
    nameLabel: "اسم السعر المشتق",
    namePlaceholder: "مثال: Booking.com، Airbnb، بدون إفطار…",
    nameHint: "يحدّد هذا الاسم السعر في مدير القنوات.",
    adjustTypeLabel: "نوع التعديل",
    percentage: "نسبة مئوية",
    fixedAmount: "مبلغ ثابت",
    adjustValueLabel: "قيمة التعديل",
    adjustValueHint: "(سالب = خصم)",
    resultPriceLabel: "السعر الناتج",
    baseLabel: "الأساس",
    applyToRooms: "التطبيق على الغرف",
    onlyMainRooms: "تظهر فقط الغرف التي لديها السعر الرئيسي.",
    noRoomsWithMain: "السعر الرئيسي غير مطبّق على أي غرفة بعد.",
    selectAll: "تحديد الكل",
    editInfo:
      "سيؤدي هذا إلى تحديث قيمة التعديل في {rooms} التي لديها هذا السعر المشتق.",
    createDerived: "إنشاء مشتق",
  },
  removeModal: {
    title: "الإزالة من الغرفة",
    syncWarnTitle: "هذا السعر متزامن مع مدير القنوات",
    syncWarnBody:
      "قد تؤدي إزالته إلى {break} للأسعار في Channex لهذه الغرفة. تحقّق من مدير القنوات قبل المتابعة.",
    syncWarnBreak: "كسر المزامنة",
    confirmText: "سيؤدي هذا الإجراء إلى إزالة السعر {rate} من الغرفة {room}.",
    roomLabel: "الغرفة",
    rateLabel: "السعر",
    statusLabel: "الحالة",
    syncedWithChannex: "متزامن مع Channex",
    removing: "جارٍ الإزالة…",
    removeAnyway: "أفهم، أزِل على أي حال",
    confirm: "الإزالة من الغرفة",
  },
  deleteModal: {
    title: "حذف السعر",
    warnTitle: "لا يمكن التراجع عن هذا الإجراء",
    warnBody: "سيتم حذف السعر {rate} من {rooms}.",
    roomsCount: "{count} غرفة | {count} غرف",
    syncedWarn:
      "بعض الغرف متزامنة مع Channex. قد يؤثر هذا في مزامنة الأسعار.",
    confirmLabel: "اكتب {name} للتأكيد",
    deleting: "جارٍ الحذف…",
    confirm: "حذف نهائي",
  },
  toasts: {
    loadError: "خطأ في تحميل أسعار الفندق",
    mainCreated: "تم إنشاء السعر في {count} غرفة | تم إنشاء السعر في {count} غرف",
    createdPartial: "تم إنشاء {ok}، وفشل {fail}",
    mainCreateFailAll: "تعذّر إنشاء السعر في أي غرفة",
    mainUpdated: "تم تحديث السعر",
    updatedPartial: "تم تحديث {ok}، وفشل {fail}",
    mainUpdateFail: "تعذّر تحديث السعر",
    derivedCreated:
      "تم إنشاء السعر المشتق في {count} غرفة | تم إنشاء السعر المشتق في {count} غرف",
    derivedCreateFail: "تعذّر إنشاء السعر المشتق",
    derivedUpdated: "تم تحديث السعر المشتق",
    derivedUpdateFail: "تعذّر تحديث السعر المشتق",
    roomAddedMain: "تمت إضافة السعر إلى {room}",
    addRateError: "خطأ في إضافة السعر",
    noMainRate: "هذه الغرفة لا تملك السعر الرئيسي. أضِفه أولًا.",
    roomAddedDerived: "تمت إضافة السعر المشتق إلى {room}",
    addDerivedError: "خطأ في إضافة السعر المشتق",
    rateRemoved: "تمت إزالة السعر من {room}",
    removeError: "خطأ في إزالة السعر",
    rateDeleted: "تم حذف السعر",
    deletedPartial: "تم حذف {ok}، وفشل {fail}",
    deleteError: "خطأ في الحذف",
  },
  errors: {
    invalidRange: "اختر نطاق تواريخ صالحًا",
    startAfterEnd: "لا يمكن أن يكون تاريخ البداية بعد تاريخ النهاية",
    minStayRange: "الحد الأدنى للإقامة: {minStay} ليالٍ، لكن النطاق يضم {nights}",
  },
};
